/* tn-upsell-swap.js — TruCBN cart subscription upsell, variant A only (toggle row), for every qualifying cart.
 * Swap: one-time 1 Box (variant 45909190902009, qty 1, no plan) <-> 90-Day plan (same variant, qty 3, selling plan 7830634745, $90).
 * Uses only the store's AJAX Cart API (/cart.js, /cart/add.js, /cart/change.js, /cart/update.js). Never places an order.
 * v2 (speed): the swap is ONE /cart/change.js on the line key (quantity + selling_plan + properties), atomic on Shopify's side,
 * and the same request returns the api-cart-items section (Section Rendering API), which is handed straight to the theme's
 * cart.build(). The switch flips at once with a pending state, and the redraw skips the theme's 0.8 s item fade.
 * If the one-request path fails, it falls back to the v1 path: add, then remove by key, with rollback, then the theme redraw.
 * Take-up tracking: cart attribute _tn_upsell=A on first view of the toggle; line property _tn_upsell=A on a toggled 90-Day line.
 */
(function (root) {
  var CFG = { variantId: 45909190902009, sellingPlanId: 7830634745, planQty: 3, tagKey: '_tn_upsell', tag: 'A', section: 'api-cart-items' };

  function isOneTime(i) { return Number(i.variant_id) === CFG.variantId && !i.selling_plan_allocation; }
  function isPlan(i) { return Number(i.variant_id) === CFG.variantId && !!i.selling_plan_allocation && Number(i.selling_plan_allocation.selling_plan.id) === CFG.sellingPlanId; }
  function find(cart, fn) { return (cart.items || []).find(fn) || null; }
  // Off state: a one-time 1 Box at qty 1 and no 90-Day line of that variant.
  function shouldShowA(cart) { var o = find(cart, isOneTime); return !!o && o.quantity === 1 && !find(cart, isPlan); }
  // On state: a 90-Day line created by the toggle (tagged), qty 3, and no one-time line.
  function showAOn(cart) { var p = find(cart, isPlan); return !!p && p.quantity === CFG.planQty && !!(p.properties && p.properties[CFG.tagKey]) && !find(cart, isOneTime); }

  function post(url, body, f) {
    return (f || root.fetch)(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status >= 400 || j.errors) throw new Error(j.description || j.message || ('HTTP ' + r.status)); return j; }); });
  }
  function getCart(f) { return (f || root.fetch)('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  // Add first, then remove the old line BY KEY; roll the added line back if the removal fails (never leave both).
  function replaceLine(oldKey, addItem, f) {
    var addedKey;
    return post('/cart/add.js', { items: [addItem] }, f).then(function (added) {
      addedKey = added.items && added.items[0] && added.items[0].key;
      return post('/cart/change.js', { id: oldKey, quantity: 0 }, f).catch(function (e) {
        var rb = addedKey ? post('/cart/change.js', { id: addedKey, quantity: 0 }, f).catch(function () {}) : Promise.resolve();
        return rb.then(function () { throw e; });
      });
    });
  }
  function swap(f) {
    return getCart(f).then(function (cart) {
      var o = find(cart, isOneTime);
      if (!o || o.quantity !== 1) throw new Error('no one-time 1 Box line (qty 1)');
      if (find(cart, isPlan)) throw new Error('90-Day line already in cart');
      var item = { id: CFG.variantId, quantity: CFG.planQty, selling_plan: CFG.sellingPlanId, properties: {} };
      item.properties[CFG.tagKey] = CFG.tag;
      return replaceLine(o.key, item, f);
    });
  }
  function unswap(f) {
    return getCart(f).then(function (cart) {
      if (!showAOn(cart)) throw new Error('no toggled 90-Day line');
      return replaceLine(find(cart, isPlan).key, { id: CFG.variantId, quantity: 1 }, f);
    });
  }

  /* v2 fast path: one atomic /cart/change.js on the line key, which also returns the redraw HTML */
  function sectionsUrl() { try { return root.location.pathname + root.location.search; } catch (e) { return '/cart'; } }
  function fastChange(key, on, f) {
    if (!key) return Promise.reject(new Error('no line key'));
    var props = {}; props[CFG.tagKey] = on ? CFG.tag : '';
    var body = on ? { id: key, quantity: CFG.planQty, selling_plan: CFG.sellingPlanId, properties: props }
                  : { id: key, quantity: 1, selling_plan: null, properties: props };
    body.sections = CFG.section; body.sections_url = sectionsUrl();
    return post('/cart/change.js', body, f).then(function (cart) {
      // trust but verify: the cart must now be exactly the target state
      var plans = (cart.items || []).filter(isPlan).length, ones = (cart.items || []).filter(isOneTime).length;
      var ok = on ? (showAOn(cart) && plans === 1) : (shouldShowA(cart) && ones === 1 && plans === 0);
      if (!ok) throw new Error('unexpected cart after change');
      return cart;
    });
  }
  // fast path first; on any failure fall back to v1 (re-reads the cart, add + remove with rollback)
  function toggle(on, key, f) {
    return fastChange(key, on, f).then(function (c) { c.__fast = true; return c; })
      .catch(function (e) { track('fast_fallback', { message: String(e && e.message || e) }); return (on ? swap(f) : unswap(f)); });
  }

  /* tracking hooks: Clarity + Shopify customer events, no-ops if absent */
  function track(name, data) {
    data = data || {}; data.variant = CFG.tag;
    try { if (root.clarity) { root.clarity('set', 'tn_upsell', CFG.tag); root.clarity('event', 'tn_upsell_' + name); } } catch (e) {}
    try { if (root.Shopify && root.Shopify.analytics && root.Shopify.analytics.publish) root.Shopify.analytics.publish('tn_upsell_' + name, data); } catch (e) {}
    try { (root.tnUpsellLog = root.tnUpsellLog || []).push([name, data]); } catch (e) {}
  }

  /* DOM */
  // v2 redraw: inject the section HTML the change request returned, via the theme's own cart.build() (drawer pages),
  // with the item fade-in switched off for this redraw. Returns false when it can't (e.g. /cart page), so the caller falls back.
  function inject(cart) {
    var doc = root.document, html = cart && cart.sections && cart.sections[CFG.section], tc = root.cart;
    if (!html || !tc || typeof tc.build !== 'function') return false;
    var tmp = doc.createElement('div'); tmp.innerHTML = html;
    var content = tmp.querySelector('[data-api-content]'); if (!content) return false;
    var drawer = doc.getElementById('cart-drawer'); if (drawer) drawer.classList.add('tn-instant');
    tc.build(content);
    return true;
  }
  // after a failure, redraw from the server so the drawer always shows the real cart
  function resync(f) {
    return (f || root.fetch)('/cart?section_id=' + CFG.section, { credentials: 'same-origin' }).then(function (r) { return r.text(); })
      .then(function (html) { var c = { sections: {} }; c.sections[CFG.section] = html; inject(c); }).catch(function () {});
  }
  function rerender(finalCart) {
    var doc = root.document, done = false;
    var onAdded = function () { done = true; doc.removeEventListener('theme:cart:added', onAdded); };
    doc.addEventListener('theme:cart:added', onAdded);
    var idx = (finalCart.items || []).findIndex(function (i) { return Number(i.variant_id) === CFG.variantId; });
    var el = doc.querySelector('#cart-drawer [data-cart-item]') || doc.querySelector('[data-cart-item]');
    if (el && idx > -1) {
      // Hand the redraw to Palo Alto: a same-quantity /cart/change on the new line, then the theme's own getCart() -> build().
      el.setAttribute('data-item-index', String(idx + 1));
      el.dispatchEvent(new CustomEvent('theme:cart:update', { detail: { id: el.getAttribute('data-item'), quantity: finalCart.items[idx].quantity } }));
    }
    setTimeout(function () { if (!done) root.location.reload(); }, 6000);
  }
  function busy(el, on) { if (!el) return; el.toggleAttribute('aria-busy', on); el.classList.toggle('is-busy', on); }
  function fail(el, e) { busy(el, false); if (el) el.setAttribute('data-tn-upsell-error', String(e && e.message || e)); track('error', { message: String(e && e.message || e) }); if (root.console) console.warn('[tn-upsell]', e); }

  var tagged = false;
  function tagCart() { // cart attribute _tn_upsell=A, hidden at checkout, kept on the order
    if (tagged) return; tagged = true;
    getCart().then(function (c) { if (!c.item_count || (c.attributes && c.attributes._tn_upsell === CFG.tag)) return; return post('/cart/update.js', { attributes: { _tn_upsell: CFG.tag } }); }).catch(function () {});
  }
  function exposure() {
    var q = root.document.querySelector('#cart-drawer.is-open [data-tn-upsell-a], [data-cart-page] [data-tn-upsell-a]');
    if (!q) return;
    try { if (root.sessionStorage.getItem('tn_upsell_exp')) return; root.sessionStorage.setItem('tn_upsell_exp', '1'); } catch (e) {}
    tagCart(); track('exposure', { state: q.getAttribute('data-state') });
  }

  function bind() {
    var d = root.document;
    d.addEventListener('click', function (ev) {
      var t = ev.target && ev.target.closest ? ev.target : null; if (!t) return;
      var tog = t.closest('[data-tn-upsell-a]');
      if (tog) {
        ev.preventDefault(); if (tog.hasAttribute('aria-busy')) return;
        var on = tog.getAttribute('aria-checked') === 'true', t0 = Date.now();
        var box = tog.closest('#cart-drawer, [data-cart-page]') || d.body;
        // instant feedback: flip the switch, spin the knob, dim the line and Checkout (Checkout is blocked while pending)
        tog.classList.toggle('is-on', !on); tog.setAttribute('aria-checked', String(!on)); busy(tog, true); box.classList.add('tn-pending');
        track(on ? 'toggle_off' : 'toggle_on');
        toggle(!on, tog.getAttribute('data-line-key')).then(function (c) {
          track(on ? 'unswap' : 'swap', { ms: Date.now() - t0, fast: !!c.__fast });
          box.classList.remove('tn-pending');
          if (!(c.__fast && inject(c))) rerender(c);
          if (!on && !(c.attributes && c.attributes[CFG.tagKey] === CFG.tag)) { tagged = false; tagCart(); }
        }).catch(function (e) {
          box.classList.remove('tn-pending'); tog.classList.toggle('is-on', on); tog.setAttribute('aria-checked', String(on)); fail(tog, e);
          resync();
        });
        return;
      }
      var co = t.closest('button[name="checkout"]');
      if (co && co.closest('.tn-pending')) { ev.preventDefault(); ev.stopPropagation(); return; }
      if (co && ev.isTrusted) track('checkout');
    }, true);
    d.addEventListener('keydown', function (ev) { var tog = ev.target && ev.target.closest && ev.target.closest('[data-tn-upsell-a]'); if (tog && (ev.key === ' ' || ev.key === 'Enter')) { ev.preventDefault(); tog.click(); } });
    ['theme:cart:added', 'theme:cart:open'].forEach(function (n) { d.addEventListener(n, function () { setTimeout(exposure, 400); }); });
    // the no-fade redraw only lasts until the drawer closes; the theme's normal open animation runs next time
    d.addEventListener('theme:cart:close', function () { setTimeout(function () { var dr = d.getElementById('cart-drawer'); if (dr) dr.classList.remove('tn-instant'); }, 700); });
    d.addEventListener('click', function (ev) { if (ev.target.closest && ev.target.closest('[data-cart-drawer-toggle]')) setTimeout(exposure, 600); });
    setTimeout(exposure, 1200);
  }

  var api = { CFG: CFG, isOneTime: isOneTime, isPlan: isPlan, shouldShowA: shouldShowA, showAOn: showAOn, swap: swap, unswap: unswap, replaceLine: replaceLine, fastChange: fastChange, toggle: toggle, inject: inject, resync: resync, track: track, rerender: rerender, bind: bind };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  root.TNUpsellSwap = api;
  if (!root.__tnUpsellBound) { root.__tnUpsellBound = true; if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', bind); else bind(); }
})(typeof window !== 'undefined' ? window : globalThis);
